import createVuexModule from '~/store/utils/createVuexModule';

export default createVuexModule<string | null>({
  stateKey: 'beginCheckoutEventCartVersion',
  initialValue: null,
  mutationName: 'setBeginCheckoutEventCartVersion',
});
